import styled from 'styled-components';

interface BaseProps {
	onMouseDown: (e: any) => void;
	onMouseUp: (e: any) => void;
	onMouseMove: (e: any) => void;
	cursor: string;
}
export const Base = styled.div<BaseProps>`
	position: absolute;
	width: 100%;
	height: 100%;
	overflow: hidden;

	cursor: ${(p) => p.cursor};
`;

// cursor: url("/img/cursors/drag.png"), pointer;

export const Box = styled.div`
	width: 222px;
	height: 90px;
	background: #ff0000;
`;
